import { TRate } from '@sv-support-sdk/shared-types/src/common/chats';

export const DEFAULT_RATE: TRate = 3;
export const SUPPORT_CES_TOPICS = 'SUPPORT_CES_TOPICS';
export const HOUR_IN_MILLISECONDS = 3600000;
